import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21ab7e46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shop-purchase" }
const _hoisted_2 = { class: "form-content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { style: {"width":"100%","font-weight":"400 !important","margin-top":"10px"} }
const _hoisted_5 = { style: {"width":"100%","font-weight":"400 !important","margin-top":"10px"} }
const _hoisted_6 = { style: {"width":"100%","font-weight":"400 !important","margin-top":"10px"} }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "foot" }

import { t } from '@/plugins/i18n'
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { getShopPurchase, updateShopPurchase } from '@/apis/usercenter'
import { useGlobal } from '@/util/useLoading'
import useEdited from '@/util/useEdited'
import { purchaseCfg } from '@/apis/setup'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  async setup(__props) {

let __temp: any, __restore: any

const store = useStore()
const api = useGlobal(purchaseCfg)
const deliveryConfigurationType = ref()

// const {
//   purchasePriceAdd,
//   payRepurchaseType
// } = await api().then((res) => res.data)
;(
  ([__temp,__restore] = _withAsyncContext(() => getShopPurchase().then(res => { deliveryConfigurationType.value = res.data.deliveryConfigurationType }))),
  await __temp,
  __restore()
)
const origin = {
  deliveryConfigurationType: deliveryConfigurationType.value
}
const [model, update, clear, reset] = useEdited(origin, () => {
  updateShopPurchase({ ...model, customerShopId: store.getters.curShop }).then((res:any) => {
    if (res.success) {
      ElMessage.success(t('修改成功'))
      clear()
    }
  })
})
const handle = (index:any) => { model.deliveryConfigurationType = index }


return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", {
          innerHTML: _unref(t)('当直发单中存在「全网断货」或「次品重拍到上限」的商品时，是否允许THE CKB直接取消发货任务').split('\n').map(v=>`<label>${v}</label>`).join('<br/>')
        }, null, 8, _hoisted_3)
      ]),
      _createVNode(_component_el_radio_group, {
        "model-value": _unref(model).deliveryConfigurationType
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_radio, {
              label: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handle(0))),
              class: "radioBox"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("遇到该场景时，需要每次都通过异常联络联系")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_radio, {
              label: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handle(1))),
              class: "radioBox"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("同意THE CKB直接取消该商品发货，剩余商品正常发货，无需询问")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_radio, {
              label: 2,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (handle(2))),
              class: "radioBox"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  innerHTML: _unref(t)('遇到该场景时，若商品为普通商品则无需询问，剩余商品正常发货；')
                }, null, 8, _hoisted_7),
                _hoisted_8,
                _createElementVNode("span", {
                  style: {"bottom":"-4px"},
                  class: "rel",
                  innerHTML: _unref(t)('若为组合商品的子商品，则需要每次都通过异常联络联系')
                }, null, 8, _hoisted_9)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model-value"]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(update)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}
}

})